import { DataProvider, Table } from '@/component/Table';
import type { RmsReport } from '@/view/rms/types';
import { columnDefs } from './columnDefs';
import { useReportRows } from './useReportRows';

interface ReportsTableProps {
  reports: RmsReport[];
  isLoading: boolean;
}

export const ReportsTable = ({ reports, isLoading }: ReportsTableProps) => {
  const rows = useReportRows(reports);

  return (
    <DataProvider
      id="rms.reports"
      initialData={rows}
      columnDefs={columnDefs}
      isLoading={isLoading}
      enableSorting
      enableFilters
      enablePagination
      initialState={{ sorting: [{ id: 'periodLabel', desc: true }] }}
    >
      <Table />
    </DataProvider>
  );
};
